import { useDispatch } from "react-redux";

import { ApplicationContextType } from "@/providers/application-context-provider";
import { setApiError } from "@/store/slices/errors/api-error.slice";

const handleTurnstileFeErrors = (
  error: string,
  dispatch: ReturnType<typeof useDispatch>,
  turnstile: ApplicationContextType["turnstile"]
) => {
  dispatch(
    setApiError({
      httpCode: null,
      errorCode: error,
      errorMessage: "",
      errorStatus: true,
      errors: null,
      modalTitle: turnstile?.titleText ?? "Turnstile Error",
      modalDescription:
        turnstile?.descriptionText ?? "Unknown turnstile issue occurred.",
      ctaPrimaryBtnLabel: turnstile?.ctaButtonOneText ?? "Try again",
      multiButton: false,
      validationEnable: false,
      isCloseIconEnabled: false,
    })
  );
};

export default handleTurnstileFeErrors;
